export function Logo({ variant = 'squircle', size = 32, className = '' }) {
  const gid = `aurora-${variant}-${size}`
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      aria-label="ClixyAds"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#60A5FA" />
          <stop offset="40%" stopColor="#A78BFA" />
          <stop offset="75%" stopColor="#EC4899" />
          <stop offset="100%" stopColor="#F9A8D4" />
        </linearGradient>
        {variant === 'squircle' && (
          <mask id={`mask-${gid}`}>
            <rect width="200" height="200" fill="white" />
            <path
              d="M 146 61 A 60 60 0 1 0 146 139 L 120 117 A 26 26 0 1 1 120 83 Z"
              fill="black"
            />
          </mask>
        )}
      </defs>
      {variant === 'squircle' ? (
        <rect
          x="10"
          y="10"
          width="180"
          height="180"
          rx="48"
          fill={`url(#${gid})`}
          mask={`url(#mask-${gid})`}
        />
      ) : (
        <path
          d="M 169 60 A 80 80 0 1 0 169 140 L 135 120 A 40 40 0 1 1 135 80 Z"
          fill={`url(#${gid})`}
        />
      )}
    </svg>
  )
}
